import abstractModel from "../../core/ShopModel";

const resource = 'retailers/shipping_costs';

const ShippingCostModel = abstractModel(resource);

ShippingCostModel.getOne = async (params) => {
  const newResource = `${resource}/${params.id}`;

  return ShippingCostModel.get({}, { path: newResource });
};

export default ShippingCostModel;
